import React from 'react'

interface NotificationSectionCardProps {
  title: string
  children: React.ReactNode
}

export const NotificationSectionCard: React.FC<
  NotificationSectionCardProps
> = ({ title, children }) => {
  return (
    <div className="bg-white max-w-[1080px] mb-6">
      <div className="">
        <h3 className="py-1 m-0 mb-3 font-semibold mb-3text-lg text-primary-900">
          {title}
        </h3>
        <div className="space-y-0 border border-solid border-gray-light-200 rounded-2xl">
          {children}
        </div>
      </div>
    </div>
  )
}
